import type { ConfiguratorPoolLine } from './configuratorPoolLine.model'
import { z } from 'zod'

export const configuratorPoolLineDtoSchema = z.object({
  id: z.number(),
  translations: z.array(z.object({
    languages_code: z.string(),
    name: z.string(),
    usps: z.array(z.object({ USP: z.string() })),
  })),
})

export type ConfiguratorPoolLineDto = z.infer<typeof configuratorPoolLineDtoSchema>

export function transformConfiguratorPoolLineDtoToConfiguratorPoolLine(
  configuratorPoolLineDto: ConfiguratorPoolLineDto,
): ConfiguratorPoolLine {
  return {
    id: configuratorPoolLineDto.id,
    translations: configuratorPoolLineDto.translations.map(translation => ({
      languagesCode: translation.languages_code,
      name: translation.name,
      usps: translation.usps.map(usp => usp.USP),
    })),
  }
}
